<template>
  <div class="container is-fluid">
    <div class="box has-background-light">
      <div class="level">
        <div class="level-left">
          <h5 class="title is-5 has-text-primary">Gerenciar Períodos</h5>
        </div>
        <div class="level-right">
          <button class="button is-primary is-rounded is-small" @click="add()">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Cadastrar</span>
          </button>
        </div>
      </div>

      <form @submit.prevent="filterRecords" class="filter-form">
        <div class="columns is-multiline is-mobile">
          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Perfil</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPerfil">
                    <option value="0" disabled>Selecione um perfil</option>
                    <option v-for="usuarioPerfil in usuariosPerfil" :key="usuarioPerfil.id" :value="usuarioPerfil.perfil">
                      {{ usuarioPerfil.perfil.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Tipo de Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbTipoPeriodo" @change="selectTipoPeriodo()">
                    <option value="0" disabled>Selecione um tipo de período</option>
                    <option v-for="td in tiposPeriodo" :key="td.id" :value="td.id">
                      {{ td.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Ano</label>
              <div class="control">
                <input class="input is-small" type="text" placeholder="Se desejar, informe um ano" v-model="nrAno">
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small"></label>
              <div class="control">
                <button type="submit" class="button is-primary is-rounded is-small">
                  <span class="icon is-small">
                    <i class="fas fa-filter"></i>
                  </span>
                  <span>Filtrar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal" :class="{ 'is-active': isProcessing }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <progress class="progress is-large is-primary" max="100">50%</progress>
          <p class="has-text-centered">Processando...</p>
        </div>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" @click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary has-text-white">
          <p class="modal-card-title has-text-white">Cadastrar Período</p>
          <button class="delete" aria-label="close" @click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="field">
              <label class="label is-small">Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="periodoPerfil.periodo" :disabled="periodoPerfil.estaFechado">
                    <option v-for="periodo in periodos" :key="periodo.id" :value="periodo">
                      {{ periodo.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="checkbox">
                <input type="checkbox" v-model="periodoPerfil.estaFechado" />
                Fechado
              </label>
            </div>

            <div class="field">
              <label class="label is-small">Versão</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="periodoPerfil.versao_plano_contas" disabled>
                    <option v-for="versao_plano_contas in versoesPlanosContas" :key="versao_plano_contas.id" :value="versao_plano_contas">
                      {{ versao_plano_contas.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Apresentação</label>
              <div class="control">
                <textarea class="textarea textarea-modal" placeholder="Descreva um texto de apresentação" v-model="periodoPerfil.mensagem" :disabled="periodoPerfil.estaFechado"></textarea>
              </div>
            </div>

            <div class="file has-name is-fullwidth" v-if="!periodoPerfil.estaFechado">
              <label class="file-label">
                <input class="file-input" type="file" ref="file" @change="uploadFile">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label">Selecione um arquivo</span>
                </span>
                <span class="file-name">{{ arquivoCSVName }}</span>
              </label>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success is-rounded" @click="save()">Salvar</button>
          <button class="button is-rounded" @click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns is-multiline" v-show="showInfo">
      <div class="column is-half">
        <div class="card">
          <header class="card-header has-background-primary has-text-white">
            <p class="card-header-title has-text-white">Períodos</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-narrow is-striped is-hoverable">
                <thead>
                  <tr class="has-background-grey-lighter">
                    <th class="is-size-7">Período</th>
                    <th class="is-size-7 has-text-centered" colspan="7">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(periodoPerfil, index) in periodosPerfis" :key="periodoPerfil.id">
                    <td class="is-size-7">{{ periodoPerfil.periodo.descricao }}</td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar período">
                        <span class="icon is-small">
                          <i class="fas fa-edit"></i>
                        </span>
                      </button>
                    </td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-danger is-outlined" @click="erase(index)" :disabled="periodoPerfil.estaFechado" title="Excluir período">
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-warning is-outlined" @click="upload(index)" :disabled="periodoPerfil.estaFechado" title="Importar balancete">
                        <span class="icon is-small">
                          <i class="fas fa-upload"></i>
                        </span>
                      </button>
                    </td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-link is-outlined" @click="processar(index)" :disabled="periodoPerfil.estaFechado" title="Processar demonstrações">
                        <span class="icon is-small">
                          <i class="fas fa-play"></i>
                        </span>
                      </button>
                    </td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-dark is-outlined" @click="gerarPDF(index)" title="Gerar demonstrações">
                        <span class="icon is-small">
                          <i class="fas fa-file-pdf"></i>
                        </span>
                      </button>
                    </td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-primary is-outlined" @click="gerarExcel(index)" title="Enviar planilha">
                        <span class="icon is-small">
                          <i class="fas fa-file-excel"></i>
                        </span>
                      </button>
                    </td>
                    <td class="is-size-7 has-text-centered">
                      <button class="button is-small is-success is-outlined" @click="callLogUpload(index)" title="Ocorrências">
                        <span class="icon is-small">
                          <i class="fas fa-th-list"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav class="pagination is-rounded is-small" role="navigation" aria-label="pagination">
              <a class="pagination-previous button is-primary" @click="previousPage()" :disabled="pagePeriodoPerfil == 1 || pagePeriodoPerfil == null">Anterior</a>
              <a class="pagination-next button is-primary" @click="nextPage()" :disabled="pagePeriodoPerfil == numpagesPeriodoPerfil">Próxima</a>
            </nav>
          </div>
        </div>
      </div>

      <div class="column is-half" v-show="mostraLogUpload">
        <div class="card">
          <header class="card-header has-background-primary has-text-white">
            <div class="card-header-title has-text-white">
              <span>Log da Importação</span>
            </div>
            <a class="card-header-icon" @click="mostraLogUpload = false" title="Fechar">
              <span class="icon has-text-white">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-narrow is-striped is-hoverable">
                <thead>
                  <tr class="has-background-grey-lighter">
                    <th class="is-size-7 has-text-left">Nº Linha</th>
                    <th class="is-size-7 has-text-left">Ocorrência</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="log in periodoPerfilLogsUpload" :key="log.id">
                    <td class="is-size-7 has-text-left">{{ log.linha }}</td>
                    <td class="is-size-7 has-text-left">{{ log.erro }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav class="pagination is-rounded is-small" role="navigation" aria-label="pagination">
              <a class="pagination-previous button is-primary" @click="previousPage()" :disabled="page == 1 || page == null">Anterior</a>
              <a class="pagination-next button is-primary" @click="nextPage()" :disabled="page == numpages">Próxima</a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    // import _ from 'lodash'
    import {http} from '../../services/config'

    export default {
        name: "PeriodoPerfil",

        data(){
            return{
                periodoPerfil: {
                    id: null,
                    perfil: null,
                    periodo: null,
                    versao_plano_contas: null,
                    fileUpload: null,
                    estaFechado: false,
                    ultimo_usuario_upload: null,
                    data_ultimo_upload: null,
                    mensagem: '',
                    index: null
                },
                periodoPerfilSelecionado: null,
                periodosPerfis: [],
                usuariosPerfil: [],
                periodoPerfilLogsUpload: [],
                periodos: [],
                versoesPlanosContas: [],
                tiposPeriodo: [],
                arquivoCSVName: null,
                previous: null,
                next: null,
                page: null,
                numpages: null,

                previousPeriodoPerfil: null,
                nextPeriodoPerfil: null,
                pagePeriodoPerfil: null,
                numpagesPeriodoPerfil: null,

                isShowModal: false,
                isProcessing: false,
                mostraLogUpload: false,
                cmbPerfil: "0",
                cmbTipoPeriodo: null,
                nrAno: null,
                showInfo: false
            }
        },

        methods: {
            add: function() {
                if (this.cmbPerfil == null) {
                    alert('Perfil não selecionado!')
                    return
                } else if (this.cmbPerfil.versao_plano_contas == null) {
                    alert('Perfil não tem uma versão associada! Inclusão de período não permitida')
                    return
                }
                if (this.cmbTipoPeriodo == null) {
                    alert('Tipo de período não selecionado!')
                    return
                }
                http.get('versoesPlanoContas/listar', {params: {
                    idPerfil: this.cmbPerfil.id
                }}).then(response =>{
                    this.versoesPlanosContas = response.data.results
                })
                this.clearFields()
                this.isShowModal = true              
            },

            edit: function(index){
                this.periodoPerfil.id = this.periodosPerfis[index].id
                this.periodoPerfil.perfil = this.periodosPerfis[index].perfil
                this.periodoPerfil.periodo = this.periodosPerfis[index].periodo
                this.periodoPerfil.versao_plano_contas = this.periodosPerfis[index].versao_plano_contas
                this.periodoPerfil.fileUpload = null
                this.periodoPerfil.estaFechado = this.periodosPerfis[index].estaFechado
                this.periodoPerfil.ultimo_usuario_upload = this.periodosPerfis[index].ultimo_usuario_upload
                this.periodoPerfil.data_ultimo_upload = this.periodosPerfis[index].data_ultimo_upload
                this.periodoPerfil.index = index
                this.isShowModal = true              
            },

            clearFields: function() {
                this.periodoPerfil = {
                    id: null,
                    perfil: null,
                    periodo: null,
                    versao_plano_contas: this.cmbPerfil.versao_plano_contas,
                    fileUpload: null,
                    estaFechado: false,
                    ultimo_usuario_upload: null,
                    data_ultimo_upload: null,
                    mensagem: '',
                    index: null }            
            },

            uploadFile: function() {
                this.periodoPerfil.fileUpload = this.$refs.file.files[0]
                this.arquivoCSVName = this.$refs.file.files[0].name
            },   

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    http.delete('/periodoPerfil/excluir/'+this.periodosPerfis[index].id).then(response =>{
                            this.periodosPerfis.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                }
            },

            save: function(){
                var data

                if (this.periodoPerfil.periodo == null) {
                    alert('Período não informado!')
                    return
                }
                if (this.periodoPerfil.versao_plano_contas == null) {
                    alert('Versão do plano de contas não informado!')
                    return
                }

                data = { id: this.periodoPerfil.id,
                    perfil: this.cmbPerfil.id,
                    periodo: this.periodoPerfil.periodo.id,
                    versao_plano_contas: this.periodoPerfil.versao_plano_contas.id,
                    estaFechado: this.periodoPerfil.estaFechado,
                    fileUpload: this.periodoPerfil.fileUpload,
                    mensagem: this.periodoPerfil.mensagem
                }

                let formData = new FormData()

                formData.append('id', data.id)
                formData.append('perfil', data.perfil)
                formData.append('periodo', data.periodo)
                formData.append('versao_plano_contas', data.versao_plano_contas)
                formData.append('estaFechado', data.estaFechado)
                formData.append('fileUpload', data.fileUpload)
                formData.append('mensagem', data.mensagem)

                if (this.periodoPerfil.id == null) {
                    http.post('/periodoPerfil/adicionar', formData, {
                        headers: {
                                "Content-Type": "multipart/form-data",
                        }}).then(response =>{
                        if (response.data.id != undefined && response.data.id != '') {
                            this.periodoPerfil.id = response.data.id
                            this.periodosPerfis.push(this.periodoPerfil)
                            this.showInfo = true
                            this.clearFields()
                        } else {
                            alert(response.request.responseText)
                        }
                    }).catch(e => {
                        console.log(e);
                    })

                } else {
                    http.put('/periodoPerfil/editar/'+this.periodoPerfil.id, formData, {
                        headers: {
                                "Content-Type": "multipart/form-data",
                        }}).then(response =>{
                        this.periodosPerfis[this.periodoPerfil.index].perfil = this.periodoPerfil.perfil
                        this.periodosPerfis[this.periodoPerfil.index].periodo = this.periodoPerfil.periodo
                        this.periodosPerfis[this.periodoPerfil.index].estaFechado = response.data.estaFechado
                        this.periodosPerfis[this.periodoPerfil.index].mensagem = response.data.mensagem
                        this.periodosPerfis[this.periodoPerfil.index].versao_plano_contas = this.periodoPerfil.versao_plano_contas
                    }).catch(e => {
                        console.log(e);
                    })
                }

            },

            nextPage: function(){
                if (this.mostraLogUpload) {

                    if (this.page != this.numpages) {
                        http.get(this.next, {params: {
                            idPeriodoPerfil: this.periodoPerfilSelecionado.id,
                        }}).then(response =>{
                            this.periodoPerfilLogsUpload = response.data.results
                            this.previous = response.data.previous
                            this.next = response.data.next
                            this.page = response.data.page
                            this.numpages = response.data.numpages
                        })
                    }

                } else {

                    if (this.pagePeriodoPerfil != this.numpagesPeriodoPerfil) {
                        http.get(this.nextPeriodoPerfil, {params: {
                            idPerfil: this.cmbPerfil.id,
                            idTipoPeriodo: this.cmbTipoPeriodo,
                            ano: this.nrAno
                        }}).then(response =>{
                            this.periodosPerfis = response.data.results
                            this.previousPeriodoPerfil = response.data.previous
                            this.nextPeriodoPerfil = response.data.next
                            this.pagePeriodoPerfil = response.data.page
                            this.numpagesPeriodoPerfil = response.data.numpages
                        })
                    }

                }
            },
            previousPage: function(){
                if (this.mostraLogUpload) {

                    if (this.page != 1) {
                        http.get(this.previous, {params: {
                            idPeriodoPerfil: this.periodoPerfilSelecionado.id,
                        }}).then(response =>{
                            this.periodoPerfilLogsUpload = response.data.results
                            this.previous = response.data.previous
                            this.next = response.data.next
                            this.page = response.data.page
                            this.numpages = response.data.numpages
                        })
                    }

                } else {
                    if (this.pagePeriodoPerfil != 1) {
                        http.get(this.previousPeriodoPerfil, {params: {
                            idPerfil: this.cmbPerfil.id,
                            idTipoPeriodo: this.cmbTipoPeriodo,
                            ano: this.nrAno
                        }}).then(response =>{
                            this.periodosPerfis = response.data.results
                            this.previousPeriodoPerfil = response.data.previous
                            this.nextPeriodoPerfil = response.data.next
                            this.pagePeriodoPerfil = response.data.page
                            this.numpagesPeriodoPerfil = response.data.numpages
                        })
                    }

                }

            },
            filterRecords: function(){
                if (this.cmbPerfil == "0") {
                    alert('Perfil não selecionado!')
                    return
                }
                if (this.cmbTipoPeriodo == null) {
                    alert('Tipo de período não informado!')
                    return
                }
                
                http.get('periodoPerfil/listar/', {params: {
                    idPerfil: this.cmbPerfil.id,
                    idTipoPeriodo: this.cmbTipoPeriodo,
                    ano: this.nrAno
                }}).then(response => {
                    this.periodosPerfis = response.data.results
                    this.previousPeriodoPerfil = response.data.previous
                    this.nextPeriodoPerfil = response.data.next
                    this.pagePeriodoPerfil = response.data.page
                    this.numpagesPeriodoPerfil = response.data.numpages

                    if (this.periodosPerfis.length != 0) {
                        this.showInfo = true
                    } else {
                        this.showInfo = false
                        alert('Não há dados associados aos parâmetros informados!')
                    }
                })

                http.get('versoesPlanoContas/listar', {params: {
                    idPerfil: this.cmbPerfil.id
                }}).then(response =>{
                    this.versoesPlanosContas = response.data.results
                })
            },

            upload: function(index){
                if (window.confirm('Confirma importação?')) {
                    this.isProcessing = true
                    http.put('/periodoPerfil/importarArquivo/'+this.periodosPerfis[index].id).then(response =>{
                        if (response.status == 200) {
                            alert('Importação Concluída!')
                        } else if (response.status == 204) {
                            alert('Arquivo não carregado! Possíveis motivos: Não informado ou não são do tipo CSV ou XLSX.')
                        }
                        this.isProcessing = false
                    }).catch(e => {
                        this.isProcessing = false
                        console.log(e);
                    })
                }
            },

            processar: function(index) {
                if (window.confirm('Confirma o processamento das demonstrações e indicadores?')) {
                    this.isProcessing = true
                    http.get('/periodoPerfil/processarDemonstracoes/', {params: {
                            idPeriodoPerfil: this.periodosPerfis[index].id
                        }}).then(response =>{
                        if (response.status == 204) {
                            this.isProcessing = false
                            alert('Processamento concluído!')
                        }
                    }).catch(e => {
                        this.isProcessing = false
                        console.log(e);
                    })
                }
            },

            gerarPDF: function(index) {
                var cFile 

                cFile = 'Dados_Economico_Financeiros_' + this.cmbPerfil.id.toString() + '_' + this.cmbPerfil.descricao + '_' + this.periodosPerfis[index].periodo.descricao + '_' + this.periodosPerfis[index].id + '.pdf'

                if (window.confirm('Confirma publicação dos resultados?')) {
                        this.isProcessing = true
                        http.get('/periodoPerfil/gerarPDF/', {params: {
                            idPeriodoPerfil: this.periodosPerfis[index].id,
                            nomeArquivo: cFile
                        }}).then(response =>{
                        if (response.status == 200) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', cFile /*'hello.pdf'*/);
                            document.body.appendChild(link);
                            link.click();                            
                            this.isProcessing = false
                        }
                    }).catch(e => {
                        console.log(e);
                    })
                }
            },

            // gerarExcel: function(index) {
            //     var cFile 

            //     cFile = 'Dados_Economico_Financeiros_' + this.cmbPerfil.id.toString() + '_' + this.cmbPerfil.descricao + '_' + this.periodosPerfis[index].periodo.descricao + '_' + this.periodosPerfis[index].id + '.xlsx'

            //     if (window.confirm('Confirma geração da planilha?')) {
            //         this.isProcessing = true
            //         http.get('/periodoPerfil/gerarExcel/', {params: {
            //                 idPeriodoPerfil: this.periodosPerfis[index].id,
            //                 nomeArquivo: cFile}}).then(response =>{
            //             if (response.status == 204) {
            //                 this.isProcessing = false
            //                 alert('Planilha gerada e enviada por e-mail!!')
            //             } else {
            //                 this.isProcessing = false
            //             }
            //         }).catch(e => {
            //             console.log(e);
            //         })
            //     }
            // },

            gerarExcel: function(index) {

                var cFile 

                cFile = 'Dados_Economico_Financeiros_' + 
                    this.cmbPerfil.id.toString() + '_' + 
                    this.cmbPerfil.descricao + '_' + 
                    this.periodosPerfis[index].periodo.descricao + '_' + 
                    this.periodosPerfis[index].id + '.xlsx'

                if (window.confirm('Confirma geração da planilha?')) {

                    this.isProcessing = true

                    http.get('/periodoPerfil/gerarExcel/', {
                        params: {
                            idPeriodoPerfil: this.periodosPerfis[index].id,
                            nomeArquivo: cFile
                        },
                        responseType: 'blob'
                    })
                    .then(response => {

                        const url = window.URL.createObjectURL(new Blob([response.data]))

                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', cFile)

                        document.body.appendChild(link)
                        link.click()

                        this.isProcessing = false

                        alert('Processo de geração da planilha concluído!!')

                    })
                    .catch(e => {
                        console.log(e)
                        this.isProcessing = false
                    })
                }
            },            

            callLogUpload: function(index) {
                this.mostraLogUpload = true
                this.periodoPerfilSelecionado = this.periodosPerfis[index]
                http.get('periodoPerfil/listarLogUpload/', {params: {
                    idPeriodoPerfil: this.periodosPerfis[index].id,
                }}).then(response => {
                    this.periodoPerfilLogsUpload = response.data.results
                    this.previous = response.data.previous
                    this.next = response.data.next
                    this.page = response.data.page
                    this.numpages = response.data.numpages
                })
            },

            selectTipoPeriodo: function() {
                http.get('periodosAccounting/listar', {params: {
                    idTipoPeriodo: this.cmbTipoPeriodo
                }}).then(response => {
                    this.periodos = response.data.results
                    if (this.periodos.length == 0) {
                        alert('Não há períodos associados ao tipo selecionado!')
                    }
                })
            },

        },

        mounted: function() {
        },
        
        created: function() {
            http.get('compartilharPerfis/listarPerfis').then(response => {
                    this.usuariosPerfil = response.data.results
            })

            http.get('tiposPeriodo/listar').then(response => {
                this.tiposPeriodo = response.data.results
            })

        }

    }
</script>

<style scoped>
</style>